import { render, staticRenderFns } from "./addPersonnel.vue?vue&type=template&id=85a896a4&scoped=true&"
import script from "./addPersonnel.vue?vue&type=script&lang=js&"
export * from "./addPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./addPersonnel.vue?vue&type=style&index=0&id=85a896a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a896a4",
  null
  
)

export default component.exports